import { useDocumentDetails } from 'hooks/useDocumentDetails';
import type { Document } from 'types';
import type { BuildingPlanReview } from 'types/Documents';

export const useBuildingPlanReview = (id: string | null) =>
  useDocumentDetails<Document<BuildingPlanReview> | null>(id);
